export default function AboutSection() {
  return (
    <section id="about" className="bg-white py-32 px-6">
      <div className="max-w-6xl mx-auto">

        {/* Label */}
        <p className="text-teal-500 text-xs font-semibold uppercase tracking-[0.25em] mb-4">
          Our Story
        </p>

        {/* Heading + paragraph */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mb-20">
          <h2 className="text-gray-900 text-5xl font-bold leading-tight" style={{ fontFamily: "'Inter', sans-serif" }}>
            Building the Future
            <br />
            of Mobile Security
          </h2>
          <div>
            <p className="text-gray-500 text-lg leading-relaxed mb-6">
              DELPAK D.O.O. represents a collective of iOS development specialists committed
              to pushing the boundaries of mobile application capabilities. Our headquarters
              in North Macedonia serves as the innovation hub where we architect solutions
              that prioritize user privacy and system efficiency.
            </p>
            <p className="text-gray-500 text-lg leading-relaxed">
              Every line of code reflects our dedication to excellence and our deep understanding
              of modern mobile user needs — delivering applications that seamlessly integrate
              with Apple&apos;s ecosystem while maintaining the highest security standards.
            </p>
          </div>
        </div>

        {/* Visual stripe */}
        <div className="rounded-2xl overflow-hidden h-72 relative">
          <img
            src="https://public.readdy.ai/ai/img_res/d7f34d19bf03a8f5aa6ef4df6412b26a.jpg"
            alt="DELPAK D.O.O. team workspace"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/50 to-transparent" />
          <div className="absolute inset-0 flex items-center px-12">
            <p className="text-white text-2xl font-semibold max-w-sm leading-snug">
              Crafting premium iOS experiences from North Macedonia to the world.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
